import React, { useState, useRef, useEffect } from 'react';
import styles from './ActionsMenu.module.css';

export default function ActionsMenu({ items = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleItemClick = (item) => {
    setIsOpen(false);
    if (!item.disabled) item.onClick();
  };

  if (items.length === 0) return null;

  return (
    <div className={styles.container} ref={containerRef}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Mais opções"
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <i className="fa fa-ellipsis-h" />
      </button>

      {isOpen && (
        <div className={styles.menu} role="menu">
          {items.map((item) => (
            <button
              type="button"
              key={item.key || item.label}
              role="menuitem"
              className={`${styles.menuItem} ${item.danger ? styles.menuItemDanger : ''}`}
              onClick={() => handleItemClick(item)}
              disabled={item.disabled}
            >
              {item.icon && <i className={item.icon} />}
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
